<template>
  <v-app>
    <Navbar />
    <v-content>
      <v-container v-if="getAppBusyAnimation" style="height: 400px;">
        <v-row class="fill-height" align-content="center" justify="center">
          <v-col class="subtitle-1 text-center" cols="12">Loading...</v-col>
          <v-col cols="6">
            <v-progress-linear
              color="deep-purple accent-4"
              indeterminate
              rounded
              height="6"
            ></v-progress-linear>
          </v-col>
        </v-row>
      </v-container>
      <router-view></router-view>
    </v-content>
  </v-app>
</template>
<script>
import Navbar from "@/components/Navbar";
import { mapMutations, mapGetters } from "vuex";
export default {
  name: "App",
  components: { Navbar },
  data() {
    return {};
  },
  methods: {
    ...mapMutations(["setAppBusyAnimation"]),
  },
  computed: {
    ...mapGetters(["getAppBusyAnimation"]),
  }  
};
</script>
<style>
/* html {
  overflow-y: auto;
} */
</style>
